import { useState, useRef, useEffect } from "react";
import { Form, FormGroup } from "react-bootstrap";
import SectionRow from "../PantallasEdit/SectionRow/SectionRow";
import { Simplebar } from '../Simplebar/Simplebar';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import { v4 as uuid } from "uuid";
import EditSection from '../PantallasEdit/EditSection/EditSection';
import useMessage from '../../Hooks/useMessage';
import { MENSAJE_ERROR_PERMISO } from "../../Utils";
import { createPortal } from 'react-dom';

function Exportar({
                      PROPIEDADES_EXPORTAR,
                      showExportar,
                      setShowExportar,
                      where,
                      showLoading,
                      hideLoading,
                      exportarCallBack,
                  }) {
    const ref = useRef(null);
    const [propiedadesSeleccionadas, setPropiedadesSeleccionadas] = useState([]);
    const { handleException } = useExceptionHandler();
    const [componentKey, setComponentKey] = useState();
    const { Warning } = useMessage();

    useEffect(() => {
        setComponentKey(uuid().substring(0, 4));
    }, []);

    const setCheckedProp = (e) => {
        const { name, checked } = e.target;
        const [property, descripcion] = name.split("*");
        let props = [...propiedadesSeleccionadas];
        if (checked) {
            props = [...props, { Descripcion: descripcion, Property: property }];
        } else {
            props = props.filter(function (element) {
                return element.Property !== property;
            });
        }
        setPropiedadesSeleccionadas(props);
    };

    const exportar = () => {
        exportarCallBack({
            PROPIEDADES_EXPORTAR: propiedadesSeleccionadas,
            Where: JSON.stringify(where),
        })
    };

    function selectAll() {
        const checkBoxes = parent.document.querySelectorAll(
            `.ck${componentKey} input[type='checkbox']`
        );

        let props = [];
        for (var i = 0; i < checkBoxes.length; i++) {
            if (checkBoxes[i].type == "checkbox") {
                checkBoxes[i].checked = true;
                const [property, descripcion] = checkBoxes[i].name.split("*");

                if (checkBoxes[i].checked) {
                    props = [...props, { Descripcion: descripcion, Property: property }];
                } else {
                    props = props.filter(function (element) {
                        return element.Property !== property;
                    });
                }
            }
            setPropiedadesSeleccionadas(props);
        }
    }

    function deselectAll() {
        const checkBoxes = parent.document.querySelectorAll(
            `.ck${componentKey} input[type='checkbox']`
        );
        let props = [];
        for (var i = 0; i < checkBoxes.length; i++) {
            if (checkBoxes[i].type == "checkbox") {
                checkBoxes[i].checked = false;
                const [property, descripcion] = checkBoxes[i].name.split("*");

                if (checkBoxes[i].checked) {
                    props = [...props, { Descripcion: descripcion, Property: property }];
                } else {
                    props = props.filter(function (element) {
                        return element.Property !== property;
                    });
                }
            }
            setPropiedadesSeleccionadas(props);
        }
    }

    return (
        <Simplebar
            showScrollY={true}
            size="sm"
            ref={ref}
            backdrop={true}
            placement={"end"}
            portal={false}
            visible={showExportar}
            setShow={(e) => {
                setShowExportar(e);
            }}
            useLoading={true}
            title="Exportar a Excel"
            btnLeft={{
                show: false,
            }}
            btnRight={{
                show: true,
                message: "Exportar",
                isComponent: true,
                size: "45px",
                height: "24px",
                with: "24px",
                iconName: "check",
                func: () => {
                    exportar();
                    setShowExportar(false);
                },
            }}
        >
            <FormGroup className={`ck${componentKey}`}>
                <div className="mb-3">
                    <EditSection title="Seleccione los campos a exportar" mb="1" style={{marginLeft: "10px", fontSize: '18px'}}>
                        <p
                            className="pl-2 font-italic mb-0"
                            style={{ fontSize: "13px", color: "#6c757d" }}
                        >
                            Se exportaran los ultimos 10,000 registros
                        </p>
                        <SectionRow colspan={3} multilinea={false} colStyle={{ width: "unset", padding: "0px" }}>
                            <button
                                variant="primary"
                                className="ml-5 "
                                key={`selectALL`}
                                name={`btnselectALL`}
                                id={"btnselectALL"}
                                onClick={selectAll}
                                style={{
                                    background: `white`,
                                    border: `none`,
                                    padding: ` 0!important`,
                                    color: `#069`,
                                    textDecoration: `underline`,
                                    cursor: `pointer`,
                                }}
                            >
                                Todos
                            </button>
                            <button
                                variant="primary"
                                className="ml-5 "
                                key={`selectALL`}
                                name={`btnselectALL`}
                                id={"btnselectALL"}
                                onClick={deselectAll}
                                style={{
                                    background: `white`,
                                    border: `none`,
                                    padding: ` 0!important`,
                                    color: `#069`,
                                    textDecoration: `underline`,
                                    cursor: `pointer`,
                                }}
                            >
                                Ninguno
                            </button>
                        </SectionRow>
                    </EditSection>
                </div>

                <div>
                    {PROPIEDADES_EXPORTAR &&
                        PROPIEDADES_EXPORTAR.map((propiedad, index) => {
                            return (
                                <SectionRow colspan={1} key={propiedad.label + index}>
                                    <Form.Check
                                        className="ml-5 "
                                        type="checkbox"
                                        aria-label={propiedad.label}
                                        name={`${propiedad.value}*${propiedad.label}`}
                                        onChange={setCheckedProp}
                                        bsPrefix='m-0'
                                    />
                                    <label
                                        htmlFor={`ck${propiedad.label}`}
                                        style={{ marginRight: "15px", marginTop: "3px" }}
                                    >
                                        {propiedad.label}
                                    </label>
                                </SectionRow>
                            );
                        })}
                </div>
            </FormGroup>
        </Simplebar>
    );
}

export default Exportar;
